import axios from 'axios';

const api = axios.create({
  baseURL: 'https://angelife.bytemagic.in/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;
